/** Same as CCParsedMessage: image type by URL extension. */
const IMAGE_EXTENSIONS = /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i;
/** Match ![alt](url) or [label](url) anywhere in body. */
const ATTACHMENT_REGEX =
  /!\[[^\]]*\]\(([^)]+)\)|\[(?:[^\]]+)\]\(([^)]+)\)/gi;

/**
 * Preview text for inbox/chat last message: show "Sent an image" / "Sent an attachment"
 * instead of raw markdown; otherwise truncate body.
 */
export function lastMessagePreview(
  body: string | null | undefined,
  maxLen = 25,
): string {
  if (body == null || body === '') return '—';
  let hasImage = false;
  let hasAttachment = false;
  let m: RegExpExecArray | null;
  ATTACHMENT_REGEX.lastIndex = 0;
  while ((m = ATTACHMENT_REGEX.exec(body)) !== null) {
    hasAttachment = true;
    const url = (m[1] ?? m[2]) ?? '';
    if (IMAGE_EXTENSIONS.test(url)) {
      hasImage = true;
      break;
    }
  }
  if (hasImage) return 'Sent an image';
  if (hasAttachment) return 'Sent an attachment';
  return body.length > maxLen ? `${body.slice(0, maxLen)}...` : body;
}
